import { useState, useEffect } from 'react';

export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/90 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-20">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <div className="w-10 h-10 flex items-center justify-center">
              <i className="ri-leaf-line text-3xl text-[#7DD3C0]"></i>
            </div>
            <h1 className="text-xl font-semibold text-[#2C2C2C]" style={{ fontFamily: 'Inter, sans-serif' }}>
              Terapia Faz Bem
            </h1>
          </div>

          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('sobre')}
              className="text-[#2C2C2C] hover:text-[#7DD3C0] transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              Sobre Mim
            </button>
            <button
              onClick={() => scrollToSection('servicos')}
              className="text-[#2C2C2C] hover:text-[#7DD3C0] transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              Serviços
            </button>
            <button
              onClick={() => scrollToSection('depoimentos')}
              className="text-[#2C2C2C] hover:text-[#7DD3C0] transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              Depoimentos
            </button>
            <button
              onClick={() => scrollToSection('contato')}
              className="text-[#2C2C2C] hover:text-[#7DD3C0] transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              Contato
            </button>
          </div>

          <div className="flex items-center gap-4">
            <a
              href="https://www.instagram.com/psimayarabenetero/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center text-[#2C2C2C] hover:text-[#7DD3C0] transition-colors duration-300 cursor-pointer"
            >
              <i className="ri-instagram-line text-2xl"></i>
            </a>
            <button
              onClick={() => scrollToSection('agendar')}
              className="bg-[#7DD3C0] text-white px-6 py-3 rounded-full hover:bg-[#6BC4B0] transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Agendar Sessão
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}